import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/redux/store';

export const editorialStateSelector = ({ editorial }: RootState) => editorial;

export const editorialState = createSelector(editorialStateSelector, (editorial) => editorial);
